import React, { useEffect, useState } from 'react'
import { Card } from '../../components/UI/Card'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { EyeIcon, UserGroupIcon } from '@heroicons/react/solid'
import { getShoppinglists, getSharedWithMe } from '../../actions/user.actions'

export default function ShoppingPanel() {
    const dispatch = useDispatch()

    const [loading, setLoading] = useState()
    const [listItems, setListItems] = useState([])

    const shoppingLists = useSelector(state => state?.user_data?.shoppinglists)
    const sharedWithMeLists = useSelector(state => state?.user_data?.shared_with_me?.filter(m => m.type === 'UserShoppinglist'))
    const currentUsersId = useSelector(state => state.auth?.user?.user?.id)

    /**
     * Hooks
     */
    useEffect(() => {
        let isMounted = true

        setLoading(true)
        
        if (isMounted) { 
            dispatch(getShoppinglists())
                .then((r) => {
                    dispatch(getSharedWithMe())
                        .then((r) => {
                            setLoading(false) 
                        }).catch(() => {    
                            setLoading(false)
                        })

            }).catch(() => {
                setLoading(false)
            })
        }

        return () => {
            isMounted = false
        }
    }, [])

    return (
        <div className="w-full px-2">
            <div 
                className="bg-an_white w-full rounded border border-an_green"
            >
                <div className="flex w-full justify-between items-center mt-[-1px] ">
                    <h5 className="flex bg-an_green-dark border p-2 text-an_white border-an_green-dark w-full rounded-t overflow-hidden">
                        <span>my lists</span>

                        <Link to={`/user-shopping-lists`} className="border border-an_white ml-auto rounded text-an_white p-1 text-xs">
                            manage
                        </Link>
                    </h5>

                </div>
                <div style={{ height: 'calc(100vh / 3)' }} className="overflow-y-auto"> 
                    {
                        shoppingLists && [...shoppingLists, ...sharedWithMeLists]?.length > 0 &&
                            [...shoppingLists, ...sharedWithMeLists].sort((a, b) => {
                                const dateA = new Date(a.updated_at)
                                const dateB = new Date(b.updated_at)                        
                                return dateB - dateA
                            }).map((list, i) => {
                                return (
                                        <div key={i} className="odd:bg-an_white-dark hover:bg-an_white-darker1">
                                            <Link to={`/user-shopping-lists/${list.user_shoppinglist_id}?view=readonly`}>
                                                <div key={i} className="flex justify-between p-2 items-center">
                                                    <div>
                                                        <small className="block text-an_green-dark" style={{ fontSize: 10 }}>Last Updated: {new Date(list?.updated_at).toLocaleString()}</small>
                                                        <div className="flex items-center">
                                                            {
                                                                currentUsersId !== parseInt(list?.user_id) &&
                                                                    <UserGroupIcon className="text-xs w-4 h-4 mr-2 mt-1 text-an_green-dark" />
                                                            }
                                                            <label className="block text-an_green-dark text-md mr-1 mt-1">{list?.name}</label>
                                                        </div>
                                                    </div>

                                                    <div className="text-center flex flex-col justify-center items-center w-12 cursor-pointer">
                                                            <button
                                                                className="text-xs w-6 h-4 px-1 mt-2 text-an_green rounded-full cursor-pointer"
                                                            >
                                                                <EyeIcon />
                                                            </button>
                                                        
                                                        <small style={{ fontSize: 10 }} className="text-xs text-an_green-dark block">{list?.ingredients?.length} Items</small>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    
                                )
                                
                            })
                    }
                </div>
            </div>
        </div>
    )
}